// extracted by mini-css-extract-plugin
export default {"modalClient":"AddClientModal_modalClient__t6pQW","modalName":"AddClientModal_modalName__EyCTJ","dateInput":"AddClientModal_dateInput__RXHY9"};